<script setup lang="ts">
  import { inject, onMounted, provide } from 'vue'
  import { tenantUsersCollectionKey } from '@gat-ship/types/injection-keys'
  import { useTenantUsersCollection } from '../../composables/useTenantUsersCollection'

  const dataSource =
    inject(tenantUsersCollectionKey, undefined) ?? useTenantUsersCollection()
  provide(tenantUsersCollectionKey, dataSource)

  onMounted(() => {
    dataSource.fetchTenantUsers()
  })

  defineExpose(dataSource)
</script>
<template>
  <slot />
</template>
